exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".talent-item[data-v-75b69f04]{display:inline-block;width:auto;text-align:left}.talent-item .talent-item-title[data-v-75b69f04]{margin-bottom:26px;padding-left:48px}.talent-item .talent-item-title img[data-v-75b69f04]{width:36px;height:32px;position:absolute;left:0;top:-2px}", ""]);

// exports
